import React from 'react';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Mechanism() {
  return <section className="bg-forest py-24 md:py-32 px-6 text-cream" data-id="element-119">
      <div className="max-w-reading mx-auto text-center" data-id="element-120">
        <FadeIn data-id="element-121">
          <h2 className="text-4xl md:text-5xl font-serif mb-4 text-white" data-id="element-122">
            The CNS-Prioritization Framework
          </h2>
          <p className="text-gold uppercase tracking-widest text-sm font-semibold mb-12" data-id="element-123">
            Central Nervous System First
          </p>

          <div className="text-lg md:text-xl font-light space-y-6 text-cream/90 text-left mb-16" data-id="element-124">
            <p data-id="element-125">
              This isn't a productivity hack. It's a biological safety protocol.
            </p>
            <p data-id="element-126">
              Instead of asking "What do I need to achieve?", we use the "Sunday
              Reset" to signal to your nervous system that Monday is an
              organized, low-friction environment.
            </p>
            <p data-id="element-127">
              We move from a "Threat State" to a "Flow State" by making 5
              micro-decisions on Sunday so your brain can finally be quiet.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12" data-id="element-128">
            <div className="bg-white/10 backdrop-blur-sm px-8 py-6 rounded-2xl border border-white/10 w-full md:w-auto" data-id="element-129">
              <p className="font-serif text-2xl text-white/70" data-id="element-130">Threat State</p>
              <p className="text-sm text-cream/60 mt-2" data-id="element-131">
                Overwhelmed & Reactive
              </p>
            </div>

            <ArrowRight className="w-8 h-8 text-gold rotate-90 md:rotate-0" data-id="element-132" />

            <div className="bg-gold/20 backdrop-blur-sm px-8 py-6 rounded-2xl border border-gold/30 w-full md:w-auto" data-id="element-133">
              <p className="font-serif text-2xl text-gold" data-id="element-134">Flow State</p>
              <p className="text-sm text-cream mt-2" data-id="element-135">Calm & Prepared</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}